module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAzUExURUdwTBZr9hBo8BRq9hZr9RVr9RNp9Qhm+hRp9RVr9hZr9RZr9hZr9RJq9hZr9RBo9hds9ZpCRB0AAAAQdFJOUwCqEHjMsEoKTI7dwvRUnSQugQzVAAAAw0lEQVRIx+2T2xKDIAxEiwLhpu7/f21pO3KzQfviTFvPC8zCTkJIbrfToYad69qhQS29+0PABtUNAEymwiL0sjIA7SmX4RcMsTVmW+HhegZy2+az3fYerHwSja+NH4+N0U7qpxnGXBwRH5sxbE0ZmKHTa2UaHJcel7f5EsMQmYDHQgf0RZZFFPRWD3O2+Lrsqd8ko1Pc64SCZ3RVGIrPt5DrAwBd6pfhM0OAFwmXDlpdFOaKFG6u564INwqVEFknRv877lM1Gzy14H0zAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phoneHomePage/expand-8.png
// module id = KWme
// module chunks = 0